import React from 'react';

type Props = {
  className?: string;
  onClick?: () => void;
};

const CommentIcon: React.FC<Props> = ({ className, onClick }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M2.39233 10.3906C2.42487 10.2709 2.35296 10.1043 2.28432 9.9843C2.26295 9.9485 2.23977 9.91382 2.21487 9.88039C1.62623 8.98769 1.31249 7.94188 1.31253 6.87258C1.30296 3.80324 3.84811 1.3125 6.99538 1.3125C9.74014 1.3125 12.0313 3.21398 12.5667 5.73809C12.6469 6.11231 12.6874 6.49395 12.6875 6.87668C12.6875 9.95039 10.2405 12.4802 7.09327 12.4802C6.59288 12.4802 5.91749 12.3545 5.54917 12.2514C5.18085 12.1483 4.81307 12.0116 4.71819 11.9749C4.62115 11.9376 4.51809 11.9184 4.41413 11.9183C4.30057 11.9179 4.18811 11.9405 4.08354 11.9848L2.22882 12.6541C2.18818 12.6717 2.14513 12.6829 2.10112 12.6875C2.06639 12.6874 2.03203 12.6804 2.00003 12.6669C1.96802 12.6534 1.93901 12.6337 1.91467 12.609C1.89033 12.5842 1.87115 12.5548 1.85824 12.5226C1.84532 12.4904 1.83893 12.4559 1.83944 12.4212C1.84172 12.3907 1.84722 12.3605 1.85585 12.3312L2.39233 10.3906Z"
        stroke="#808080"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CommentIcon;
